import { render } from "./AccountWarningDefaulting.vue?vue&type=template&id=f7a24d92"
import script from "./AccountWarningDefaulting.vue?vue&type=script&lang=js"
export * from "./AccountWarningDefaulting.vue?vue&type=script&lang=js"

import exportComponent from "/home/elias/web-farm/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__